import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

export const Container = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-top: 2px;
  line-height: 40px;
  ${_ellipsis()};
  color: ${({ theme }) => theme.primaryBackgroundColor};

  &.undefined-date {
    color: ${ColorPalette.HEX.Manatee};
  }
`;
